<div class="gap-4 mx-4 mt-4">
  <div class="sticky-tab-panel">
    <div>
      <label class="!text-[20px] !font-medium roboto text-[#21252A]">
        RFI #1: RFI-001 - Clarification on Design Layout
      </label>
      <div class="justify-between flex">
        <!-- Tab Buttons -->
        <div class="flex space-x-4 mt-2">
          <button
            (click)="setActiveTab('General')"
            [class.border-b-orange-500]="activeTab === 'General'"
            [class.text-orange-600]="activeTab === 'General'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            General
          </button>
          <button
            (click)="setActiveTab('Related Items')"
            [class.border-b-orange-500]="activeTab === 'Related Items'"
            [class.text-orange-600]="activeTab === 'Related Items'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Related Items (0)
          </button>
          <button
            (click)="setActiveTab('Emails')"
            [class.border-b-orange-500]="activeTab === 'Emails'"
            [class.text-orange-600]="activeTab === 'Emails'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Emails (0)
          </button>
          <button
            (click)="setActiveTab('Change History')"
            [class.border-b-orange-500]="activeTab === 'Change History'"
            [class.text-orange-600]="activeTab === 'Change History'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Change History
          </button>
        </div>
        <!-- GENERAL TAB BUTTONS -->
        <div class="flex space-x-2 mb-[10px]" *ngIf="activeTab === 'General'">
          <button
            class="border border-[#e76b3f] !h-[38px] text-[#e76b3f] px-3 pb-2 rounded"
          >
            Export <mat-icon class="pt-[8px]">expand_more</mat-icon>
          </button>
          <button
            class="border border-[#e76b3f] !h-[38px] text-[#e76b3f] px-4 pb-2 rounded"
          >
            Edit <mat-icon class="pt-[4px] !text-base">edit</mat-icon>
          </button>
          <button
            class="bg-[#e76b3f] text-white px-4 py-2 !h-[38px] rounded hover:bg-orange-600"
          >
            Close RFI
          </button>
        </div>
        <!-- Email -->
        <div class="flex space-x-2 mb-[10px]" *ngIf="activeTab === 'Emails'">
          <button class="bg-[#E76B3F] text-white px-4 py-2 rounded">
            Compose Email
          </button>
        </div>

        <div class="flex space-x-2 mb-[10px]" *ngIf="activeTab === 'Change History'">
          <button
            class="border border-[#302E2E] !h-[38px] text-[#302E2E] px-3 pb-2 rounded"
          >
            Export <mat-icon class="pt-[8px]">expand_more</mat-icon>
          </button>
      </div>
    </div>

    <hr />

    <!-- Dynamic Content Rendering -->
    <ng-container *ngIf="activeTab === 'General'">
      <app-clarification-design></app-clarification-design>
    </ng-container>
    <ng-container *ngIf="activeTab === 'Related Items'">
      <app-rfi-related-items></app-rfi-related-items>
    </ng-container>
    <ng-container *ngIf="activeTab === 'Emails'">
      <app-rfi-emails></app-rfi-emails>
    </ng-container>
    <ng-container *ngIf="activeTab === 'Change History'">
      <app-rfi-change-history></app-rfi-change-history>
    </ng-container>
  </div>
</div>
